import { createContentPropTypes } from '../../../helpers/content';

const content = {
	title: 'Payment details',
	fromLabel: 'From',
	toLabel: 'To',
	amountLabel: 'Amount',
	refLabel: 'Reference',
	paymentDateLabel: 'Payment date',
	createdByLabel: 'Created by',
	createdOnLabel: 'Created on',
	bacsTypeLabel: 'Type',
	bacsCreditLabel: 'Bacs Credit',
	bacsDebitLabel: 'Bacs Direct Debit',
	transactionCodeLabel: 'Transaction Code',
	bacsIdLabel: 'BACS ID',
	submissionDateLabel: 'Submission Date',
	settlementDateLabel: 'Settlement Date',
	bacsDebitSettlementDateLabel: 'Collection date',
	hmrcRefLabel: 'HMRC Reference',
	individualPaymentsLabel: 'Individual payments',
	totalAmountLabel: 'Total amount',
	transactions: 'Transactions',
	back: 'Back',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
